import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { HelmetProvider } from "react-helmet-async";
import AuthProvider from "./providers/AuthProvider";
import ErrorBoundary from "./components/public/ErrorBoundary";
import LocalStorageProvider from "./providers/LocalStorageProvider";
import QueryProvider from "./providers/QueryProvider";
import FlowbiteThemeProvider from "./providers/FlowbiteThemeProvider";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import { initializeErrorReporter } from "./utils/errorReporter";
import App from "./App";

initializeErrorReporter();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

if (process.env.NODE_ENV === "production") {
  disableReactDevTools();
}

root.render(
  <ErrorBoundary>
    <LocalStorageProvider>
      <BrowserRouter>
        <HelmetProvider>
          <QueryProvider>
            <AuthProvider>
              <FlowbiteThemeProvider>
                <App />
              </FlowbiteThemeProvider>
            </AuthProvider>
          </QueryProvider>
        </HelmetProvider>
      </BrowserRouter>
    </LocalStorageProvider>
  </ErrorBoundary>
);

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
